import { useAlert } from '~/systems/alert';
import Modal from '../Modal/Modal';
import EditorButton from '../editor/EditorButton/EditorButton';

export default function AlertContent() {
  const alertSys = useAlert();

  function close() {
    alertSys.hideAlert();
  }

  return (
    <Modal
      title="Error"
      isVisible={alertSys.show}
      onClose={close}
      body={<p style={{ margin: 0 }}>{alertSys.text}</p>}
      footer={
        <EditorButton kind="primary" onClick={close}>
          Close
        </EditorButton>
      }
    />
  );
}
